import { forceTwoDigits } from 'utils/sanitizers';
import { memo } from 'react';
import { TimerProps, useTimer } from './useTimer';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import styles from './Timer.module.scss';

const Timer = ({
  className,
  time,
  showSeconds = true,
  showDays = true,
}: TimerProps) => {
  const { t } = useTranslation('active_loan_debt_restructuring');
  const { timer } = useTimer({ time, showSeconds, showDays });

  if (!timer) return null;

  // Render timer
  return (
    <div
      className={classes(styles.timer, className)}
      data-testid="timer-layout"
    >
      {showDays && (
        <>
          <div
            className={styles['hours-minutes-seconds']}
            data-testid="timer-days-container"
          >
            <span className={styles.number} data-testid="timer-days-text">
              {forceTwoDigits(timer?.days)}
            </span>
            <span className={styles.text} data-testid="timer-days-value">
              {t('common:days', {
                count: timer?.days,
              })}
            </span>
          </div>
          <div className={styles.separator} data-testid="timer-days-separator">
            :
          </div>
        </>
      )}
      <div
        className={styles['hours-minutes-seconds']}
        data-testid="timer-hours-container"
      >
        <span className={styles.number} data-testid="timer-hours-text">
          {forceTwoDigits(timer?.hours)}
        </span>
        <span className={styles.text} data-testid="timer-hours-value">
          {t('common:hours', {
            count: timer?.hours,
          })}
        </span>
      </div>
      <div className={styles.separator} data-testid="timer-minutes-separator">
        :
      </div>
      <div
        className={styles['hours-minutes-seconds']}
        data-testid="timer-minutes-container"
      >
        <span className={styles.number} data-testid="timer-minutes-text">
          {forceTwoDigits(timer?.minutes)}
        </span>
        <span className={styles.text} data-testid="timer-minutes-value">
          {t('common:minutes', {
            count: timer?.minutes,
          })}
        </span>
      </div>
      {showSeconds && (
        <>
          <div
            className={styles.separator}
            data-testid="timer-seconds-separator"
          >
            :
          </div>
          <div
            className={styles['hours-minutes-seconds']}
            data-testid="timer-seconds-container"
          >
            <span className={styles.number} data-testid="timer-seconds-text">
              {forceTwoDigits(timer?.seconds)}
            </span>
            <span className={styles.text} data-testid="timer-seconds-value">
              {t('common:seconds', {
                count: timer?.seconds,
              })}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

Timer.displayName = 'Card';

export default memo(Timer);
